import { SvgIcon } from "@material-ui/core";
import { SvgIconProps } from "@chhjit/react-components";

export const AtticIcon = ({ className, fontSize = 24 }: SvgIconProps) => (
  <SvgIcon
    className={className}
    width="48"
    height="48"
    viewBox="0 0 48 48"
    style={{ fill: "none", fontSize: fontSize }}
    fill="currentColor"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.3065 14.6504C22.656 14.6504 22.9392 14.9337 22.9392 15.2831V22.1524C22.9392 22.5019 22.656 22.7851 22.3065 22.7851C21.9571 22.7851 21.6738 22.5019 21.6738 22.1524V15.2831C21.6738 14.9337 21.9571 14.6504 22.3065 14.6504Z"
      fill="#226937"
    />
    <path
      d="M45.9787 20.3186C45.8883 19.6588 45.5448 19.0713 45.0025 18.6645L42.6344 16.8749V6.45337H43.945C44.3156 6.45337 44.6229 6.14606 44.6229 5.77548C44.6229 5.40489 44.3156 5.09758 43.945 5.09758H34.6352C34.2646 5.09758 33.9573 5.40489 33.9573 5.77548C33.9573 6.14606 34.2646 6.45337 34.6352 6.45337H35.9458V11.8223L27.332 5.32355C26.8981 4.99816 26.3649 4.81738 25.8225 4.81738C25.2802 4.81738 24.7469 4.99816 24.3131 5.32355L6.61546 18.6645C6.08218 19.0713 5.73871 19.6588 5.63929 20.3186C5.5489 20.9784 5.72063 21.6383 6.11833 22.1715C6.58834 22.7952 7.33855 23.1658 8.11587 23.1658C8.66723 23.1658 9.18243 22.994 9.62532 22.6596L9.97783 22.3975V44.9037H41.6311V22.3975L41.9836 22.6596C42.4265 22.994 42.9417 23.1658 43.4931 23.1658C44.2794 23.1658 45.0206 22.7952 45.4906 22.1715C45.9064 21.6383 46.0781 20.9784 45.9787 20.3186Z"
      fill="#F0CBA7"
    />
    <path
      d="M22.1978 4.35579C22.4418 4.35579 22.6859 4.43714 22.8937 4.5908L40.5823 17.9408C41.0885 18.3205 41.1879 19.0436 40.8083 19.5497C40.5823 19.848 40.2388 20.0107 39.8863 20.0107C39.6423 20.0107 39.3983 19.9384 39.1904 19.7757L22.1978 6.94988L5.20516 19.7757C4.99727 19.9293 4.75323 20.0107 4.50919 20.0107C4.15668 20.0107 3.81321 19.857 3.58725 19.5497C3.20762 19.0436 3.30705 18.3205 3.81321 17.9408L21.5018 4.5908C21.7097 4.43714 21.9537 4.35579 22.1978 4.35579ZM22.1978 3C21.6554 3 21.1222 3.18077 20.6883 3.50616L2.99974 16.8562C2.46646 17.2629 2.12299 17.8505 2.02356 18.5103C1.93318 19.1701 2.10491 19.8299 2.50261 20.3632C2.97262 20.9869 3.72283 21.3574 4.50015 21.3574C5.0515 21.3574 5.5667 21.1857 6.0096 20.8513L22.1887 8.6401L38.3679 20.8513C38.8107 21.1857 39.3259 21.3574 39.8773 21.3574C40.6637 21.3574 41.4048 20.9869 41.8748 20.3632C42.2816 19.8299 42.4443 19.1701 42.3539 18.5103C42.2635 17.8505 41.92 17.2629 41.3777 16.8562L23.7072 3.50616C23.2734 3.18077 22.7401 3 22.1978 3Z"
      fill="#EA7200"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M32.9992 3.78613C33.3736 3.78613 33.6771 4.08964 33.6771 4.46403V11.0803C33.6771 11.4547 33.3736 11.7582 32.9992 11.7582C32.6248 11.7582 32.3213 11.4547 32.3213 11.0803V4.46403C32.3213 4.08964 32.6248 3.78613 32.9992 3.78613Z"
      fill="#EA7200"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M38.3498 3.78613C38.7242 3.78613 39.0277 4.08964 39.0277 4.46403V15.2833C39.0277 15.6576 38.7242 15.9612 38.3498 15.9612C37.9754 15.9612 37.6719 15.6576 37.6719 15.2833V4.46403C37.6719 4.08964 37.9754 3.78613 38.3498 3.78613Z"
      fill="#EA7200"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M30.3418 3.96696C30.3418 3.59257 30.6453 3.28906 31.0197 3.28906H40.3385C40.7129 3.28906 41.0164 3.59257 41.0164 3.96696C41.0164 4.34135 40.7129 4.64486 40.3385 4.64486H31.0197C30.6453 4.64486 30.3418 4.34135 30.3418 3.96696Z"
      fill="#EA7200"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M36.669 41.7396V19.2334H38.0248V43.0954H6.37158V19.5498H7.72738V41.7396H36.669Z"
      fill="#EA7200"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.37158 27.3136C6.37158 26.9392 6.67509 26.6357 7.04948 26.6357H37.3469C37.7213 26.6357 38.0248 26.9392 38.0248 27.3136C38.0248 27.688 37.7213 27.9915 37.3469 27.9915H7.04948C6.67509 27.9915 6.37158 27.688 6.37158 27.3136Z"
      fill="#EA7200"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1938 32.5109C18.1938 32.1365 18.4974 31.833 18.8717 31.833H25.7321C26.1064 31.833 26.41 32.1365 26.41 32.5109V42.4172C26.41 42.7916 26.1064 43.0951 25.7321 43.0951C25.3577 43.0951 25.0542 42.7916 25.0542 42.4172V33.1888H19.5496V42.4172C19.5496 42.7916 19.2461 43.0951 18.8717 43.0951C18.4974 43.0951 18.1938 42.7916 18.1938 42.4172V32.5109Z"
      fill="#EA7200"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.1797 15.9158C20.6322 15.9158 19.3777 17.1703 19.3777 18.7178C19.3777 20.2653 20.6322 21.5197 22.1797 21.5197C23.7272 21.5197 24.9816 20.2653 24.9816 18.7178C24.9816 17.1703 23.7272 15.9158 22.1797 15.9158ZM18.1123 18.7178C18.1123 16.4714 19.9333 14.6504 22.1797 14.6504C24.426 14.6504 26.247 16.4714 26.247 18.7178C26.247 20.9641 24.426 22.7851 22.1797 22.7851C19.9333 22.7851 18.1123 20.9641 18.1123 18.7178Z"
      fill="#226937"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M22.1796 14.6504C22.529 14.6504 22.8123 14.9337 22.8123 15.2831V22.1524C22.8123 22.5019 22.529 22.7851 22.1796 22.7851C21.8301 22.7851 21.5469 22.5019 21.5469 22.1524V15.2831C21.5469 14.9337 21.8301 14.6504 22.1796 14.6504Z"
      fill="#226937"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M18.1123 18.7178C18.1123 18.3684 18.3956 18.0851 18.745 18.0851H25.6143C25.9638 18.0851 26.247 18.3684 26.247 18.7178C26.247 19.0672 25.9638 19.3505 25.6143 19.3505H18.745C18.3956 19.3505 18.1123 19.0672 18.1123 18.7178Z"
      fill="#226937"
    />
  </SvgIcon>
);
